(() => {
  const root = window.FaithGlowRoot || '/';
  const $ = id => document.getElementById(id);
  const configNode = $('faithglow-product-data');
  const config = {...(window.FaithGlowSettings || {}), ...(configNode ? JSON.parse(configNode.textContent) : {})};
  const currency = config.currency || document.querySelector('.currency')?.textContent.trim() || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const photos = Array.from(document.querySelectorAll('[data-thumb] img')).map(image => image.src);
  const descriptions = Array.from(document.querySelectorAll('[data-thumb]')).map(button => button.getAttribute('aria-label'));
  const cartDialog = $('cart-dialog');
  let variant = config.variants?.find(item => item.id === config.variantId);
  let pending = false;
  async function request(path, data) {
    const response = await fetch(root + path, data ? {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(data)} : {headers:{'Accept':'application/json'},cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your bag. Please try again.');
    return result;
  }
  function showError(error) {
    const status = $('product-status');
    if (status) status.textContent = error.message;
  }
  function checkoutURL() {
    return config.discountCode ? root + 'discount/' + encodeURIComponent(config.discountCode) + '?redirect=' + encodeURIComponent(root + 'checkout') : root + 'checkout';
  }
  async function refreshCart() {
    const cart = await request('cart.js');
    if ($('cart-count')) $('cart-count').textContent = cart.item_count;
    const body = $('cart-body');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<p>Your bag is waiting for a little Christmas magic.</p><button class="button" id="continue-shopping">Continue shopping →</button>';
      $('continue-shopping').onclick = () => cartDialog.close();
      return;
    }
    let pendingBundleSavings = 0;
    body.innerHTML = cart.items.map(item => {
      const bundle = item.properties?._FaithGlowBundle === '2';
      const expectedBundlePrice = bundle ? Math.round(item.original_line_price * 0.85) : item.final_line_price;
      const displayLinePrice = bundle && item.final_line_price > expectedBundlePrice + 1 ? expectedBundlePrice : item.final_line_price;
      pendingBundleSavings += Math.max(0, item.final_line_price - displayLinePrice);
      const allocations = (item.line_level_discount_allocations || []).map(allocation => '<small>' + escape(allocation.discount_application.title) + ' −' + money(allocation.amount) + '</small>').join('');
      return '<div class="cart-line">' + (item.image ? '<img src="' + escape(item.image) + '" alt="' + escape(item.product_title) + '">' : '') + '<div><a href="' + escape(item.url) + '">' + escape(item.product_title) + '</a><small>' + (bundle ? 'Two-piece gift bundle' : escape(item.variant_title === 'Default Title' ? '' : item.variant_title)) + '</small><p>' + money(displayLinePrice) + '</p>' + allocations + '<div class="quantity"><button type="button" data-key="' + escape(item.key) + '" data-quantity="' + Math.max(0, item.quantity - (bundle ? 2 : 1)) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-key="' + escape(item.key) + '" data-quantity="' + (item.quantity + (bundle ? 2 : 1)) + '" aria-label="Increase quantity">+</button></div><button class="remove" data-key="' + escape(item.key) + '" data-quantity="0">Remove</button></div></div>';
    }).join('') + '<div class="cart-total"><span>Subtotal</span><strong>' + money(cart.total_price - pendingBundleSavings) + '</strong></div><p class="cart-bundle-note">' + (pendingBundleSavings ? 'Bundle savings apply automatically at checkout. ' : '') + 'Shipping and taxes calculated at checkout.</p><button type="button" class="button" id="cart-checkout" style="width:100%">Checkout →</button><button class="button secondary" id="continue-shopping" style="width:100%;margin-top:12px">Continue shopping</button><p class="cart-error" id="cart-status" role="status"></p>';
    body.querySelectorAll('[data-key]').forEach(button => button.addEventListener('click', async () => {
      if (pending) return;
      pending = true;button.disabled = true;
      try {await request('cart/change.js', {id:button.dataset.key, quantity:Number(button.dataset.quantity)});await refreshCart();}
      catch (error) {if ($('cart-status')) $('cart-status').textContent = error.message;}
      finally {pending = false;button.disabled = false;}
    }));
    $('cart-checkout').onclick = () => window.location.assign(checkoutURL());
    $('continue-shopping').onclick = () => cartDialog.close();
  }
  function updatePrice() {
    if (!variant) return;
    const size = Number(document.querySelector('input[name="quantity"]:checked')?.value || 1);
    const bundlePrice = Math.round(variant.price * 1.7);
    $('variant-id').value = variant.id;
    $('bundle-total').textContent = money(size === 2 ? bundlePrice : variant.price);
    const singlePrice = document.querySelector('.price-row .price');
    if (singlePrice) singlePrice.textContent = money(variant.price);
    const prices = document.querySelectorAll('.bundle-price');
    if (prices[0]) prices[0].firstChild.textContent = money(variant.price);
    if (prices[1]) prices[1].firstChild.textContent = money(bundlePrice);
    $('add-cart').disabled = !variant.available;
    $('product-status').textContent = variant.available ? '' : 'Currently unavailable. Please contact us for availability.';
  }
  document.querySelectorAll('[data-thumb]').forEach(button => button.onclick = () => {
    const index = Number(button.dataset.thumb);
    $('product-main').src = photos[index];$('product-main').alt = descriptions[index];
    document.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
  document.querySelectorAll('[data-image]').forEach(button => button.onclick = () => {
    const index = Number(button.dataset.image);if (!photos[index]) return;
    $('large-image').src = photos[index];$('large-image').alt = descriptions[index];$('lightbox').showModal();
  });
  document.querySelectorAll('input[name="quantity"]').forEach(input => input.onchange = updatePrice);
  $('product-variant')?.addEventListener('change', event => {
    variant = config.variants.find(item => item.id === Number(event.target.value));updatePrice();
  });
  $('product-form')?.addEventListener('submit', async event => {
    event.preventDefault();if (!variant || !variant.available || pending) return;
    pending = true;$('add-cart').disabled = true;
    const size = Number(document.querySelector('input[name="quantity"]:checked')?.value || 1);
    try {
      await request('cart/add.js', {items:[{id:variant.id, quantity:size, properties:{_FaithGlowBundle:String(size)}}]});
      await refreshCart();cartDialog.showModal();
    } catch (error) {showError(error);} finally {pending = false;$('add-cart').disabled = !variant.available;}
  });
  $('open-cart')?.addEventListener('click', async () => {
    cartDialog.showModal();$('cart-body').textContent = 'Loading your bag…';
    try {await refreshCart();} catch (error) {$('cart-body').textContent = error.message;}
  });
  $('open-menu')?.addEventListener('click', () => $('menu-dialog').showModal());
  document.querySelectorAll('[data-close]').forEach(button => button.onclick = () => $(button.dataset.close).close());
  document.querySelectorAll('#menu-dialog a').forEach(link => link.onclick = () => $('menu-dialog').close());
  document.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  }));
  if ($('year')) $('year').textContent = new Date().getFullYear();
  updatePrice();
  request('cart.js').then(cart => {if ($('cart-count')) $('cart-count').textContent = cart.item_count;}).catch(() => {});
})();
